module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_4.f0a4a68c.jpg";